import React from 'react';
import { util } from '../Util';
import { Button, Col, FormGroup, Row } from 'reactstrap';
import { FormLabel } from '@mui/material';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';

export default class LowboyDispatchFilter extends React.Component {
    render() {
        const {
            activeDate,
            onDateChange,
            onEquipmentTypeChange,
            equipmentTypes,
            selectedEquipmentTypeId,
            nameFilter,
            onNameFilterChange,
            equipmentsLoading,
            resourcesLoading,
            onRefreshClicked,
        } = this.props;

        if (!activeDate) {
            return null;
        }

        return (
            <div className="p-1 user-filters">
                <Row>
                    <Col className="col-3">
                        <FormGroup>
                            <FormLabel>Date</FormLabel>
                            <input
                                className="form-control"
                                id="user-filter-date"
                                type="date"
                                value={util.date.getInputFormat(activeDate)}
                                onChange={onDateChange}
                                disabled={equipmentsLoading}
                            />
                        </FormGroup>
                    </Col>
                    <Col className="col-4">
                        <FormGroup>
                            <FormLabel>Equipment Type</FormLabel>
                            <Select
                                value={
                                    equipmentTypes.find(
                                        (et) => et.id == selectedEquipmentTypeId
                                    ) || 'All'
                                }
                                options={equipmentTypes}
                                getOptionLabel={(et) => et.description}
                                onChange={onEquipmentTypeChange}
                                disabled={equipmentsLoading}
                                isClearable
                            />
                        </FormGroup>
                    </Col>
                    <Col className="col-4">
                        <FormGroup>
                            <FormLabel>Name Filter</FormLabel>
                            <input
                                className="form-control"
                                id="user-filter-date"
                                type="text"
                                value={nameFilter || ''}
                                onChange={onNameFilterChange}
                                disabled={equipmentsLoading}
                                placeholder="Filter by equipment name"
                            />
                        </FormGroup>
                    </Col>
                    <Col className="col-1 refresh-nudge">
                        <Button
                            type="button"
                            outline={!resourcesLoading && !equipmentsLoading}
                            color="success"
                            onClick={onRefreshClicked}
                            disabled={equipmentsLoading}
                            title="Refresh Data"
                        >
                            <FontAwesomeIcon
                                icon={faRefresh}
                                spin={resourcesLoading && equipmentsLoading}
                            />
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}
